var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { apiGetOneClientRfpShareDocumentMessageFile } from '@/actions/ClientRfpShareDocumentActions';
import { RfpClientOneFileAllView } from '@/components/pages/rfp/client/RfpClientOneFileAllView';
import RfpOneArrowLink from '@/container/Client/Rfp/One/Parts/Head/RfpOneArrowLink';
import RfpContentSubMenu from '@/container/Client/Rfp/One/Parts/SubMenu/RfpContentSubMenu';
import { rfpOneUseCase } from '@/container/Client/Rfp/One/UseCase/RfpOneUseCase';
import Layout from '@/container/Layout';
import { notifyError } from '@/helpers/action';
import { isAdmin } from '@/helpers/auth';
import { useResourceUpload } from '@/hooks/file/useResource';
import { useResourceFromInput } from '@/hooks/file/useResourceView';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { useRfpClientOneFileFetchAll } from '@/pages/rfp/client/RfpClientOneFileAll/useRfpClientOneFileAllFetch';
import { useRfpClientOneFileAllSubmit } from '@/pages/rfp/client/RfpClientOneFileAll/useRfpClientOneFileAllSubmit';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { openFileNewTab } from '@/utils/file/open';
export const RfpClientOneFileAllPage = (props) => {
    const { formDispatch, formState, offers, profile, rfp } = props;
    const unmountRef = useUnmountRef();
    const auth = useTypeSelector((state) => state.auth);
    const dispatch = useDispatch();
    const isAdminUser = isAdmin(profile);
    const { isCanUpdateMember, isMemberAdmin, members } = rfpOneUseCase.useMemberInfo(rfp, profile, auth);
    // タブリンク用の閲覧申請ID
    const viewRequestId = useMemo(() => { var _a, _b; return (_b = (_a = formState.viewRequests) === null || _a === void 0 ? void 0 : _a.find(({ files }) => (files === null || files === void 0 ? void 0 : files.length) > 0)) === null || _b === void 0 ? void 0 : _b.id; }, [formState]);
    // 閲覧申請データ取得
    const { fetchViewRequest, isLoading } = useRfpClientOneFileFetchAll({
        dispatch,
        formDispatch,
        id: rfp.id,
        unmountRef,
    });
    const hasInitialViewRequest = formState.viewRequests !== null;
    const { inspectFileStatus: onInspectFileStatus, isUploading, uploadFileToStorage, } = useResourceUpload({
        dispatch,
        unmountRef,
    });
    const { inputUploadFileEvent: onUploadFile } = useResourceFromInput({
        fileType: 'object',
        uploadFileToStorage,
    });
    const { onSubmit } = useRfpClientOneFileAllSubmit({
        dispatch,
        formDispatch,
        id: rfp.id,
        unmountRef,
    });
    /**
     * ファイルダウンロードを実行
     */
    const onClickFileLink = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { value } = event.currentTarget;
            const { payload } = yield wrapDispatch(dispatch, apiGetOneClientRfpShareDocumentMessageFile({ path: { id: rfp.id, share_document_message_file_id: value } }, {}));
            if (!unmountRef.current) {
                openFileNewTab(payload.url);
            }
        }
        catch (error) {
            if (!unmountRef.current) {
                notifyError('ファイルの取得中にエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。');
            }
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }), [dispatch, rfp.id, unmountRef]);
    // コンサル一覧を取得
    useEffect(() => {
        if (hasInitialViewRequest) {
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchViewRequest();
        }))();
    }, [fetchViewRequest, hasInitialViewRequest]);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main rfp_common_container rfp_client_one_container' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${rfp.name}｜PROFFIT` }) }), _jsx(RfpClientOneFileAllView, { id: rfp.id, initialValues: formState.formValues, isAdminUser: isAdminUser, isCallEnd: rfp.is_call_end, isDifferentUserForRequestProfessional: rfp.is_different_user_for_request_professional, isLoading: isLoading, isUploading: isUploading, onClickFileLink: onClickFileLink, onInspectFileStatus: onInspectFileStatus, onSubmit: onSubmit, onUploadFile: onUploadFile, rows: formState.viewRequests || [], stepComponent: _jsx(RfpOneArrowLink, { activeIndex: 1, offers: offers, rfp: rfp }), subContentComponent: _jsx(RfpContentSubMenu, { className: 'flex flex-col gap-y-32', isCanUpdateMember: isCanUpdateMember, isMemberAdmin: isMemberAdmin, members: members, rfp: rfp }), title: rfp.name, unansweredQuestionCount: rfp.unanswered_online_question_count, unapprovedCount: rfp.view_request_unapproved_count, unreadFileCount: rfp.unread_share_document_message_count, unreadMessageCount: rfp.unread_negotiate_message_count, viewRequestId: viewRequestId })] })));
};
